var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { nanoid } from '@reduxjs/toolkit';
import { Mutex } from 'async-mutex';
import i18n from '../../../localization/i18next';
import { authApi } from '../auth/auth-api';
import { setCurrentUser } from '../auth/authSlice';
import { MachineStatus } from '../chat-machine/machine-status';
import { setChatApiStatus } from '../common/commonSlice';
import { monteurApi } from '../common/monteur-api';
import { setConversationId, setUnInitializedConversationId } from './chatSlice';
import { ResolutionType } from './enums/resolution-type';
import { getValidToken } from './token-expired';
var API_BASE_URL = process.env.REACT_APP_CHAT_API_BASE_URL;
var API_TOKEN = localStorage.getItem('AccessToken');
var defaultConversationName = 'New chat';
var DISLIKE = -1;
var NEUTRAL = 0;
var LIKE = 1;
var mutex = new Mutex();
var handleResponse = function (response, queryArgs, dispatch, chatQuestionDto) { return __awaiter(void 0, void 0, void 0, function () {
    var responseError, chat_1, reader, decoder, processEvent, dataStream, chat;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!response.ok && !!response.body) {
                    responseError = {
                        error: response.statusText,
                        status: 'FETCH_ERROR'
                    };
                    return [2 /*return*/, { error: responseError }];
                }
                if (!!((_a = response.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('text/event-stream'))) return [3 /*break*/, 2];
                return [4 /*yield*/, response.json()];
            case 1:
                chat_1 = (_b.sent());
                dispatch(chatApi.util.updateQueryData('getConversation', queryArgs, function (conversation) {
                    var currentMessage = conversation.messages[conversation.messages.length - 1];
                    currentMessage.message_id = chat_1.message_id;
                    currentMessage.doc_content = chat_1.doc_content;
                    currentMessage.question = chat_1.question;
                    currentMessage.question_type = chat_1.question_type;
                    currentMessage.answer = "".concat(currentMessage.answer).concat(chat_1.response);
                    currentMessage.sources = chat_1.sources;
                    currentMessage.time = chat_1.time;
                    currentMessage.expert_opinion = chat_1.expert_opinion;
                }));
                dispatch(chatApi.util.updateQueryData('getConversations', chatQuestionDto.user_id, function (conversations) {
                    var conversation = conversations.find(function (item) { return item.conversation_id === chat_1.conversation_id; });
                    if (conversation && conversation.conversation_name === defaultConversationName)
                        conversation.conversation_name = chat_1.conversation_name;
                }));
                return [2 /*return*/, { data: chat_1 }];
            case 2:
                reader = response.body.getReader();
                decoder = new TextDecoder('utf-8');
                processEvent = function (event) {
                    var eventLines = event.trim().split('\n');
                    var dataLine = eventLines.find(function (line) { return line.startsWith('data:'); });
                    if (dataLine) {
                        var data = dataLine.replace('data:', '');
                        return JSON.parse(data);
                    }
                };
                dataStream = function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                                var buffer, done, finalAnswer, _a, value, readerDone, position, _loop_1, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _c.trys.push([0, 4, , 5]);
                                            buffer = '';
                                            done = false;
                                            finalAnswer = void 0;
                                            _c.label = 1;
                                        case 1:
                                            if (!!done) return [3 /*break*/, 3];
                                            return [4 /*yield*/, (reader === null || reader === void 0 ? void 0 : reader.read())];
                                        case 2:
                                            _a = _c.sent(), value = _a.value, readerDone = _a.done;
                                            done = readerDone;
                                            buffer += decoder.decode(value, { stream: true });
                                            position = void 0;
                                            _loop_1 = function () {
                                                var rawEvent = buffer.slice(0, position);
                                                buffer = buffer.slice(position + 2);
                                                var chat_2 = processEvent(rawEvent);
                                                if (chat_2) {
                                                    finalAnswer = finalAnswer !== null && finalAnswer !== void 0 ? finalAnswer : { response: '' };
                                                    finalAnswer.message_id = chat_2.message_id;
                                                    finalAnswer.doc_content = chat_2.doc_content;
                                                    finalAnswer.question = chat_2.question;
                                                    finalAnswer.question_type = chat_2.question_type;
                                                    finalAnswer.response = "".concat(finalAnswer.response).concat(chat_2.response);
                                                    finalAnswer.thinking_process = chat_2.thinking_process;
                                                    finalAnswer.sources = chat_2.sources;
                                                    finalAnswer.time = chat_2.time;
                                                    finalAnswer.expert_opinion = chat_2.expert_opinion;
                                                    dispatch(chatApi.util.updateQueryData('getConversation', queryArgs, function (conversation) {
                                                        var currentMessage = conversation.messages[conversation.messages.length - 1];
                                                        currentMessage.message_id = chat_2.message_id;
                                                        currentMessage.doc_content = chat_2.doc_content;
                                                        currentMessage.question = chat_2.question;
                                                        currentMessage.question_type = chat_2.question_type;
                                                        currentMessage.answer = "".concat(currentMessage.answer).concat(chat_2.response);
                                                        currentMessage.thinking_process = chat_2.thinking_process;
                                                        currentMessage.sources = chat_2.sources;
                                                        currentMessage.time = chat_2.time;
                                                        currentMessage.expert_opinion = chat_2.expert_opinion;
                                                    }));
                                                    if (chat_2.conversation_name !== '') {
                                                        dispatch(chatApi.util.updateQueryData('getConversations', chatQuestionDto.user_id, function (conversations) {
                                                            var conversation = conversations.find(function (item) { return item.conversation_id === chat_2.conversation_id; });
                                                            if (conversation)
                                                                conversation.conversation_name = chat_2.conversation_name;
                                                        }));
                                                    }
                                                }
                                            };
                                            while ((position = buffer.indexOf('\n\n')) > 0) {
                                                _loop_1();
                                            }
                                            return [3 /*break*/, 1];
                                        case 3:
                                            resolve(finalAnswer);
                                            return [3 /*break*/, 5];
                                        case 4:
                                            _b = _c.sent();
                                            reject(new Error('Unable to proccess the data stream.'));
                                            return [3 /*break*/, 5];
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    });
                }); };
                return [4 /*yield*/, dataStream()];
            case 3:
                chat = _b.sent();
                return [2 /*return*/, { data: chat }];
        }
    });
}); };
export var chatApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: [
        'DislikedConversations',
        'MessageFeedback',
        'ConversationsList',
        'AuditGraph',
        'ChatApiStatus'
    ]
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        getHealth: builder.query({
            queryFn: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var response, release, apiResponse, loginResponse, responseError, responseError;
                    var _c, _d;
                    var dispatch = _b.dispatch;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0: return [4 /*yield*/, fetch("".concat(API_BASE_URL, "health"), {
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "Bearer ".concat(API_TOKEN)
                                    }
                                })];
                            case 1:
                                response = _e.sent();
                                if (!(response.status === 401)) return [3 /*break*/, 12];
                                if (!!mutex.isLocked()) return [3 /*break*/, 9];
                                return [4 /*yield*/, mutex.acquire()];
                            case 2:
                                release = _e.sent();
                                _e.label = 3;
                            case 3:
                                _e.trys.push([3, , 7, 8]);
                                return [4 /*yield*/, dispatch(authApi.endpoints.getToken.initiate())];
                            case 4:
                                apiResponse = _e.sent();
                                if (!apiResponse.data) return [3 /*break*/, 6];
                                loginResponse = apiResponse.data;
                                dispatch(setCurrentUser(loginResponse.currentUser));
                                localStorage.setItem('AccessToken', loginResponse.accessToken);
                                return [4 /*yield*/, fetch("".concat(API_BASE_URL, "health"), {
                                        method: 'GET',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: "Bearer ".concat(API_TOKEN)
                                        }
                                    })];
                            case 5:
                                response = _e.sent();
                                _e.label = 6;
                            case 6: return [3 /*break*/, 8];
                            case 7:
                                release();
                                return [7 /*endfinally*/];
                            case 8: return [3 /*break*/, 12];
                            case 9: return [4 /*yield*/, mutex.waitForUnlock()];
                            case 10:
                                _e.sent();
                                return [4 /*yield*/, fetch("".concat(API_BASE_URL, "health"), {
                                        method: 'GET',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: "Bearer ".concat(API_TOKEN)
                                        }
                                    })];
                            case 11:
                                response = _e.sent();
                                _e.label = 12;
                            case 12:
                                if (!(!response.ok && !!response.body)) return [3 /*break*/, 14];
                                _c = {};
                                return [4 /*yield*/, response.json()];
                            case 13:
                                responseError = (_c.error = _e.sent(),
                                    _c.status = 'FETCH_ERROR',
                                    _c);
                                return [2 /*return*/, { error: responseError }];
                            case 14:
                                if (!(!response.ok && !!!response.body)) return [3 /*break*/, 15];
                                responseError = {
                                    error: response.statusText,
                                    status: 'FETCH_ERROR'
                                };
                                return [2 /*return*/, { error: responseError }];
                            case 15:
                                _d = {};
                                return [4 /*yield*/, response.json()];
                            case 16: return [2 /*return*/, (_d.data = (_e.sent()), _d)];
                        }
                    });
                });
            },
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var response, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                response = _d.sent();
                                if (response.data)
                                    dispatch(setChatApiStatus('ok'));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                dispatch(setChatApiStatus('off'));
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
            keepUnusedDataFor: 0,
            providesTags: ['ChatApiStatus']
        }),
        setDocumentFilter: builder.mutation({
            queryFn: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var documents, token, request, response, release, apiResponse, loginResponse, responseError, responseError, chat;
                    var _c;
                    var dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                documents = arg.documents.join(',');
                                return [4 /*yield*/, MachineStatus(dispatch)];
                            case 1:
                                _d.sent();
                                return [4 /*yield*/, getValidToken(dispatch)];
                            case 2:
                                token = _d.sent();
                                request = {
                                    user_id: arg.user_id,
                                    user_name: arg.user_name,
                                    conversation_id: arg.conversation_id,
                                    document_filter_list: documents,
                                    chat_start_location: arg.chat_start_location,
                                    company_id: arg.company_id
                                };
                                return [4 /*yield*/, fetch("".concat(API_BASE_URL, "chat/setup/"), {
                                        method: 'POST',
                                        body: JSON.stringify(request),
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: "Bearer ".concat(token)
                                        }
                                    })];
                            case 3:
                                response = _d.sent();
                                if (!(response.status === 401)) return [3 /*break*/, 14];
                                if (!!mutex.isLocked()) return [3 /*break*/, 11];
                                return [4 /*yield*/, mutex.acquire()];
                            case 4:
                                release = _d.sent();
                                _d.label = 5;
                            case 5:
                                _d.trys.push([5, , 9, 10]);
                                return [4 /*yield*/, dispatch(authApi.endpoints.getToken.initiate())];
                            case 6:
                                apiResponse = _d.sent();
                                if (!apiResponse.data) return [3 /*break*/, 8];
                                loginResponse = apiResponse.data;
                                dispatch(setCurrentUser(loginResponse.currentUser));
                                localStorage.setItem('AccessToken', loginResponse.accessToken);
                                return [4 /*yield*/, fetch("".concat(API_BASE_URL, "chat/setup/"), {
                                        method: 'POST',
                                        body: JSON.stringify(request),
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: "Bearer ".concat(API_TOKEN)
                                        }
                                    })];
                            case 7:
                                response = _d.sent();
                                _d.label = 8;
                            case 8: return [3 /*break*/, 10];
                            case 9:
                                release();
                                return [7 /*endfinally*/];
                            case 10: return [3 /*break*/, 14];
                            case 11: return [4 /*yield*/, mutex.waitForUnlock()];
                            case 12:
                                _d.sent();
                                return [4 /*yield*/, fetch("".concat(API_BASE_URL, "chat/setup/"), {
                                        method: 'POST',
                                        body: JSON.stringify(request),
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: "Bearer ".concat(API_TOKEN)
                                        }
                                    })];
                            case 13:
                                response = _d.sent();
                                _d.label = 14;
                            case 14:
                                if (!(!response.ok && !!response.body)) return [3 /*break*/, 16];
                                _c = {};
                                return [4 /*yield*/, response.json()];
                            case 15:
                                responseError = (_c.error = _d.sent(),
                                    _c.status = 'FETCH_ERROR',
                                    _c);
                                return [2 /*return*/, { error: responseError }];
                            case 16:
                                if (!response.ok && !!!response.body) {
                                    responseError = {
                                        error: response.statusText,
                                        status: 'FETCH_ERROR'
                                    };
                                    return [2 /*return*/, { error: responseError }];
                                }
                                return [4 /*yield*/, response.json()];
                            case 17:
                                chat = (_d.sent());
                                return [2 /*return*/, { data: chat }];
                        }
                    });
                });
            },
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var response, conversation_1, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                response = _d.sent();
                                conversation_1 = {
                                    conversation_id: response.data.conversation_id,
                                    conversation_name: response.data.conversation_name,
                                    time: response.data.time
                                };
                                dispatch(chatApi.util.updateQueryData('getConversations', arg.user_id, function (conversations) {
                                    conversations.unshift(conversation_1);
                                }));
                                dispatch(setConversationId(arg.conversation_id));
                                dispatch(setUnInitializedConversationId(arg.conversation_id));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        getAnswer: builder.query({
            queryFn: function (chatQuestion_1, _a) { return __awaiter(void 0, [chatQuestion_1, _a], void 0, function (chatQuestion, _b) {
                var queryArgs, question, conversationChat, conversation, token, response, release, apiResponse, loginResponse;
                var _c, _d, _e;
                var dispatch = _b.dispatch;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            queryArgs = {
                                userId: chatQuestion.user_id,
                                conversationId: chatQuestion.conversation_id
                            };
                            question = chatQuestion.question_type === 'text' ? chatQuestion.question : '';
                            conversationChat = {
                                user_id: queryArgs.userId,
                                conversation_id: queryArgs.conversationId,
                                message_id: nanoid(),
                                feedback: 0,
                                question: question,
                                question_type: chatQuestion.question_type,
                                answer: '',
                                sources: [],
                                doc_content: [],
                                expert_opinion: [],
                                is_translation: false,
                                resolution_type: ResolutionType.None,
                                time: new Date(),
                                thinking_process: ''
                            };
                            dispatch(chatApi.util.updateQueryData('getConversation', queryArgs, function (conversation) {
                                conversation.messages.push(conversationChat);
                            }));
                            conversation = {
                                conversation_id: chatQuestion.conversation_id,
                                conversation_name: defaultConversationName,
                                time: new Date()
                            };
                            dispatch(chatApi.util.updateQueryData('getConversations', chatQuestion.user_id, function (conversations) {
                                if (!conversations.some(function (conversation) { return conversation.conversation_id === chatQuestion.conversation_id; }))
                                    return __spreadArray([conversation], __read(conversations), false);
                            }));
                            return [4 /*yield*/, MachineStatus(dispatch)];
                        case 1:
                            _f.sent();
                            return [4 /*yield*/, getValidToken(dispatch)];
                        case 2:
                            token = _f.sent();
                            return [4 /*yield*/, fetch("".concat(API_BASE_URL, "chat/answer/"), {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Accept-Language': (_c = i18n.language) !== null && _c !== void 0 ? _c : 'en',
                                        Authorization: "Bearer ".concat(token)
                                    },
                                    body: JSON.stringify(chatQuestion)
                                })];
                        case 3:
                            response = _f.sent();
                            if (!(response.status === 401)) return [3 /*break*/, 14];
                            if (!!mutex.isLocked()) return [3 /*break*/, 11];
                            return [4 /*yield*/, mutex.acquire()];
                        case 4:
                            release = _f.sent();
                            _f.label = 5;
                        case 5:
                            _f.trys.push([5, , 9, 10]);
                            return [4 /*yield*/, dispatch(authApi.endpoints.getToken.initiate())];
                        case 6:
                            apiResponse = _f.sent();
                            if (!apiResponse.data) return [3 /*break*/, 8];
                            loginResponse = apiResponse.data;
                            dispatch(setCurrentUser(loginResponse.currentUser));
                            localStorage.setItem('AccessToken', loginResponse.accessToken);
                            return [4 /*yield*/, fetch("".concat(API_BASE_URL, "chat/answer/"), {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Accept-Language': (_d = i18n.language) !== null && _d !== void 0 ? _d : 'en',
                                        Authorization: "Bearer ".concat(loginResponse.accessToken)
                                    },
                                    body: JSON.stringify(chatQuestion)
                                })];
                        case 7:
                            response = _f.sent();
                            _f.label = 8;
                        case 8: return [3 /*break*/, 10];
                        case 9:
                            release();
                            return [7 /*endfinally*/];
                        case 10: return [3 /*break*/, 14];
                        case 11: return [4 /*yield*/, mutex.waitForUnlock()];
                        case 12:
                            _f.sent();
                            return [4 /*yield*/, fetch("".concat(API_BASE_URL, "chat/answer/"), {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Accept-Language': (_e = i18n.language) !== null && _e !== void 0 ? _e : 'en',
                                        Authorization: "Bearer ".concat(API_TOKEN)
                                    },
                                    body: JSON.stringify(chatQuestion)
                                })];
                        case 13:
                            response = _f.sent();
                            _f.label = 14;
                        case 14: return [2 /*return*/, handleResponse(response, queryArgs, dispatch, chatQuestion)];
                    }
                });
            }); }
        }),
        getTranslationAnswer: builder.query({
            queryFn: function (chatQuestionDto_1, _a) { return __awaiter(void 0, [chatQuestionDto_1, _a], void 0, function (chatQuestionDto, _b) {
                var queryArgs, chatTranslationDto, conversationChat, conversation, token, response, release, apiResponse, loginResponse;
                var dispatch = _b.dispatch;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            queryArgs = {
                                userId: chatQuestionDto.user_id,
                                conversationId: chatQuestionDto.conversation_id
                            };
                            chatTranslationDto = {
                                question: chatQuestionDto.question,
                                question_type: 'text',
                                response: chatQuestionDto.response,
                                sources: [],
                                doc_content: [],
                                is_translation: true,
                                is_skippable: false
                            };
                            conversationChat = {
                                user_id: queryArgs.userId,
                                conversation_id: queryArgs.conversationId,
                                message_id: nanoid(),
                                feedback: 0,
                                question: chatQuestionDto.question,
                                question_type: 'text',
                                answer: '',
                                sources: [],
                                doc_content: [],
                                expert_opinion: [],
                                is_translation: true,
                                resolution_type: ResolutionType.None,
                                time: new Date(),
                                thinking_process: ''
                            };
                            dispatch(chatApi.util.updateQueryData('getConversation', queryArgs, function (conversation) {
                                conversation.messages.push(conversationChat);
                            }));
                            conversation = {
                                conversation_id: chatQuestionDto.conversation_id,
                                conversation_name: defaultConversationName,
                                time: new Date()
                            };
                            dispatch(chatApi.util.updateQueryData('getConversations', chatQuestionDto.user_id, function (conversations) {
                                if (!conversations.some(function (conversation) {
                                    return conversation.conversation_id === chatQuestionDto.conversation_id;
                                }))
                                    return __spreadArray([conversation], __read(conversations), false);
                            }));
                            return [4 /*yield*/, MachineStatus(dispatch)];
                        case 1:
                            _c.sent();
                            return [4 /*yield*/, getValidToken(dispatch)];
                        case 2:
                            token = _c.sent();
                            return [4 /*yield*/, fetch("".concat(API_BASE_URL, "conversations/conversation/").concat(chatQuestionDto.user_id, "/").concat(chatQuestionDto.conversation_id), {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "Bearer ".concat(token)
                                    },
                                    body: JSON.stringify(chatTranslationDto)
                                })];
                        case 3:
                            response = _c.sent();
                            if (!(response.status === 401)) return [3 /*break*/, 14];
                            if (!!mutex.isLocked()) return [3 /*break*/, 11];
                            return [4 /*yield*/, mutex.acquire()];
                        case 4:
                            release = _c.sent();
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, , 9, 10]);
                            return [4 /*yield*/, dispatch(authApi.endpoints.getToken.initiate())];
                        case 6:
                            apiResponse = _c.sent();
                            if (!apiResponse.data) return [3 /*break*/, 8];
                            loginResponse = apiResponse.data;
                            dispatch(setCurrentUser(loginResponse.currentUser));
                            localStorage.setItem('AccessToken', loginResponse.accessToken);
                            return [4 /*yield*/, fetch("".concat(API_BASE_URL, "conversations/conversation/").concat(chatQuestionDto.user_id, "/").concat(chatQuestionDto.conversation_id), {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "Bearer ".concat(API_TOKEN)
                                    },
                                    body: JSON.stringify(chatTranslationDto)
                                })];
                        case 7:
                            response = _c.sent();
                            _c.label = 8;
                        case 8: return [3 /*break*/, 10];
                        case 9:
                            release();
                            return [7 /*endfinally*/];
                        case 10: return [3 /*break*/, 14];
                        case 11: return [4 /*yield*/, mutex.waitForUnlock()];
                        case 12:
                            _c.sent();
                            return [4 /*yield*/, fetch("".concat(API_BASE_URL, "conversations/conversation/").concat(chatQuestionDto.user_id, "/").concat(chatQuestionDto.conversation_id), {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "Bearer ".concat(API_TOKEN)
                                    },
                                    body: JSON.stringify(chatTranslationDto)
                                })];
                        case 13:
                            response = _c.sent();
                            _c.label = 14;
                        case 14: return [2 /*return*/, handleResponse(response, queryArgs, dispatch, chatQuestionDto)];
                    }
                });
            }); }
        }),
        getConversations: builder.query({
            query: function (userId) { return ({
                url: "Chat/get-conversations?userId=".concat(userId),
                method: 'GET'
            }); },
            onQueryStarted: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var uninitialized_conversation_id, response, _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled, getState = _b.getState;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                uninitialized_conversation_id = getState().chat
                                    .uninitialized_conversation_id;
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, queryFulfilled];
                            case 2:
                                response = _d.sent();
                                if (!uninitialized_conversation_id && response.data.length)
                                    dispatch(setConversationId(response.data[0].conversation_id));
                                return [3 /*break*/, 4];
                            case 3:
                                _c = _d.sent();
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        getConversation: builder.query({
            query: function (query) { return ({
                url: "Chat/get-conversation?userId=".concat(query.userId, "&conversationId=").concat(query.conversationId),
                method: 'GET'
            }); }
        }),
        dislikeAnswer: builder.mutation({
            query: function (feedback) { return ({
                url: 'Chat/dislike-chat',
                method: 'POST',
                body: feedback
            }); },
            invalidatesTags: ['DislikedConversations'],
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var queryArg, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                queryArg = {
                                    conversationId: arg.conversationId,
                                    userId: arg.userId
                                };
                                dispatch(chatApi.util.updateQueryData('getConversation', queryArg, function (conversation) {
                                    var currentMessage = conversation.messages.find(function (message) { return message.message_id === arg.messageId; });
                                    if (currentMessage)
                                        currentMessage.feedback = DISLIKE;
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        likeAnswer: builder.mutation({
            query: function (feedback) { return ({
                url: 'Chat/like-chat',
                method: 'POST',
                body: feedback
            }); },
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var queryArg, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                queryArg = {
                                    conversationId: arg.conversationId,
                                    userId: arg.userId
                                };
                                dispatch(chatApi.util.updateQueryData('getConversation', queryArg, function (conversation) {
                                    var currentMessage = conversation.messages.find(function (message) { return message.message_id === arg.messageId; });
                                    if (currentMessage)
                                        currentMessage.feedback = LIKE;
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        neutralAnswer: builder.mutation({
            query: function (feedback) { return ({
                url: 'Chat/neutral-chat',
                method: 'POST',
                body: feedback
            }); },
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var queryArg, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                queryArg = {
                                    conversationId: arg.conversationId,
                                    userId: arg.userId
                                };
                                dispatch(chatApi.util.updateQueryData('getConversation', queryArg, function (conversation) {
                                    var currentMessage = conversation.messages.find(function (message) { return message.message_id === arg.messageId; });
                                    if (currentMessage)
                                        currentMessage.feedback = NEUTRAL;
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        clearChat: builder.mutation({
            query: function (command) { return ({
                url: 'Chat/clear-chat',
                method: 'POST',
                body: command
            }); },
            onQueryStarted: function (_a, _b) {
                return __awaiter(this, arguments, void 0, function (_c, _d) {
                    var _e;
                    var userId = _c.userId, conversationId = _c.conversationId;
                    var dispatch = _d.dispatch, queryFulfilled = _d.queryFulfilled;
                    return __generator(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                _f.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _f.sent();
                                dispatch(chatApi.util.updateQueryData('getConversation', { userId: userId, conversationId: conversationId }, function () { return ({
                                    document_list: [],
                                    messages: [],
                                    faqs: []
                                }); }));
                                dispatch(chatApi.util.updateQueryData('getConversations', userId, function (conversations) {
                                    var filteredConversations = conversations.filter(function (conversation) { return conversation.conversation_id !== conversationId; });
                                    if (filteredConversations.length) {
                                        dispatch(setConversationId(filteredConversations[0].conversation_id));
                                        return filteredConversations;
                                    }
                                    else
                                        dispatch(chatApi.util.resetApiState());
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _e = _f.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        getDislikedConversations: builder.query({
            query: function (query) { return ({
                url: 'Chat/get-disliked-conversations',
                method: 'POST',
                body: query
            }); },
            providesTags: ['DislikedConversations']
        }),
        updateTrainingStatus: builder.mutation({
            query: function (request) { return ({
                url: 'Chat/update-training-status',
                method: 'POST',
                body: request
            }); },
            invalidatesTags: ['DislikedConversations']
        }),
        getMessageFeedback: builder.query({
            query: function (query) {
                return "Chat/get-message-feedback?userId=".concat(query.userId, "&conversationId=").concat(query.conversationId, "&messageId=").concat(query.messageId);
            },
            providesTags: ['MessageFeedback']
        }),
        resolveMessageFeedback: builder.mutation({
            query: function (feedback) { return ({
                url: 'Chat/resolve-feedback',
                method: 'POST',
                body: feedback
            }); },
            invalidatesTags: ['MessageFeedback', 'DislikedConversations'],
            onQueryStarted: function (arg_1, _a) {
                return __awaiter(this, arguments, void 0, function (arg, _b) {
                    var queryArg, _c;
                    var queryFulfilled = _b.queryFulfilled, dispatch = _b.dispatch;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                queryArg = {
                                    conversationId: arg.conversationId,
                                    userId: arg.userId
                                };
                                dispatch(chatApi.util.updateQueryData('getConversation', queryArg, function (conversation) {
                                    var currentMessage = conversation.messages.find(function (message) { return message.message_id === arg.messageId; });
                                    if (currentMessage)
                                        currentMessage.resolution_type = ResolutionType.Resolved;
                                }));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        getConversationsList: builder.query({
            query: function (query) { return ({
                url: "Chat/get-list",
                method: 'POST',
                body: query
            }); },
            providesTags: ['ConversationsList']
        }),
        getAuditData: builder.query({
            query: function (query) { return ({
                url: "Chat/get-audit-data",
                method: 'POST',
                body: query
            }); },
            providesTags: ['AuditGraph']
        }),
        getExpertOpinion: builder.query({
            query: function (request) { return ({
                url: "Chat/get-expert-opinion?userId=".concat(request.userId, "&conversationId=").concat(request.conversationId, "&messageId=").concat(request.messageId),
                method: 'GET'
            }); },
            keepUnusedDataFor: 0
        }),
        keepAlive: builder.query({
            queryFn: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var response, release, apiResponse, loginResponse, responseError;
                    var _c, _d;
                    var dispatch = _b.dispatch;
                    return __generator(this, function (_e) {
                        switch (_e.label) {
                            case 0: return [4 /*yield*/, fetch("".concat(API_BASE_URL, "keep_alive"), {
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "Bearer ".concat(API_TOKEN)
                                    }
                                })];
                            case 1:
                                response = _e.sent();
                                if (!(response.status === 401)) return [3 /*break*/, 12];
                                if (!!mutex.isLocked()) return [3 /*break*/, 9];
                                return [4 /*yield*/, mutex.acquire()];
                            case 2:
                                release = _e.sent();
                                _e.label = 3;
                            case 3:
                                _e.trys.push([3, , 7, 8]);
                                return [4 /*yield*/, dispatch(authApi.endpoints.getToken.initiate())];
                            case 4:
                                apiResponse = _e.sent();
                                if (!apiResponse.data) return [3 /*break*/, 6];
                                loginResponse = apiResponse.data;
                                dispatch(setCurrentUser(loginResponse.currentUser));
                                localStorage.setItem('AccessToken', loginResponse.accessToken);
                                return [4 /*yield*/, fetch("".concat(API_BASE_URL, "keep_alive"), {
                                        method: 'GET',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: "Bearer ".concat(API_TOKEN)
                                        }
                                    })];
                            case 5:
                                response = _e.sent();
                                _e.label = 6;
                            case 6: return [3 /*break*/, 8];
                            case 7:
                                release();
                                return [7 /*endfinally*/];
                            case 8: return [3 /*break*/, 12];
                            case 9: return [4 /*yield*/, mutex.waitForUnlock()];
                            case 10:
                                _e.sent();
                                return [4 /*yield*/, fetch("".concat(API_BASE_URL, "keep_alive"), {
                                        method: 'GET',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: "Bearer ".concat(API_TOKEN)
                                        }
                                    })];
                            case 11:
                                response = _e.sent();
                                _e.label = 12;
                            case 12:
                                if (!(!response.ok && !!response.body)) return [3 /*break*/, 14];
                                _c = {};
                                return [4 /*yield*/, response.json()];
                            case 13:
                                responseError = (_c.error = _e.sent(),
                                    _c.status = 'FETCH_ERROR',
                                    _c);
                                MachineStatus(dispatch);
                                return [2 /*return*/, { error: responseError }];
                            case 14:
                                _d = {};
                                return [4 /*yield*/, response.json()];
                            case 15: return [2 /*return*/, (_d.data = (_e.sent()), _d)];
                        }
                    });
                });
            }
        })
    }); }
});
export var useLazyGetAnswerQuery = chatApi.useLazyGetAnswerQuery, useLazyGetTranslationAnswerQuery = chatApi.useLazyGetTranslationAnswerQuery, useGetConversationsQuery = chatApi.useGetConversationsQuery, useLazyGetConversationQuery = chatApi.useLazyGetConversationQuery, useSetDocumentFilterMutation = chatApi.useSetDocumentFilterMutation, useClearChatMutation = chatApi.useClearChatMutation, useDislikeAnswerMutation = chatApi.useDislikeAnswerMutation, useLikeAnswerMutation = chatApi.useLikeAnswerMutation, useNeutralAnswerMutation = chatApi.useNeutralAnswerMutation, useGetConversationsListQuery = chatApi.useGetConversationsListQuery, useGetDislikedConversationsQuery = chatApi.useGetDislikedConversationsQuery, useUpdateTrainingStatusMutation = chatApi.useUpdateTrainingStatusMutation, useLazyGetMessageFeedbackQuery = chatApi.useLazyGetMessageFeedbackQuery, useResolveMessageFeedbackMutation = chatApi.useResolveMessageFeedbackMutation, useGetAuditDataQuery = chatApi.useGetAuditDataQuery, useLazyGetExpertOpinionQuery = chatApi.useLazyGetExpertOpinionQuery, useLazyKeepAliveQuery = chatApi.useLazyKeepAliveQuery;
